export default __webpack_public_path__ + "static/Plots0082-57dd3ef6af62a2dac5334b59c33c2abe.jpg";